/**
 * Global button ripple - Vastradevi Theme
 * Adds an expanding circle from the click point on primary/CTA buttons.
 */
(function () {
  'use strict';

  // Buttons that should NOT ripple: icon buttons, steppers, toggles, swatches,
  // close/remove links - many carry overflowing badges/tooltips that a clipped
  // ripple container would cut off.
  var SKIP = [
    '.header-icon-btn', '.mobile-menu-toggle', '.mobile-bottom-nav__item',
    '.col-card__wishlist', '.wishlist-detail-btn', '.cart-drawer__close',
    '.cart-drawer__qty-btn', '.product-qty-btn', '.cart-page-qty-btn',
    '.quickview-qty-btn', '.swatch-btn', '.col-card__img-swatch',
    '.thumbnail-btn', '.main-image-zoom-btn', '.srch-close', '.quickview-close',
    '.share-btn', '.hero-dot', '.cart-drawer__remove', '.cart-page-remove',
    '.cart-drawer__discount-remove', '.copy-link-btn'
  ].join(',');

  // Elements that DO get a ripple.
  var CLICKABLE = [
    'button', '.btn-primary', '.btn-secondary', '.btn-gold',
    '.btn-outline-gold', '.btn-outline-white', '.col-card__cta-btn'
  ].join(',');

  document.addEventListener('click', function (e) {
    var el = e.target.closest(CLICKABLE);
    if (!el) return;
    if (el.closest(SKIP)) return;
    if (el.disabled) return;

    var rect = el.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height);

    var ripple = document.createElement('span');
    ripple.className = 'vd-ripple';
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';

    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.style.overflow = 'hidden';

    // Remove any lingering ripple, then add the new one
    var old = el.querySelector('.vd-ripple');
    if (old) old.remove();
    el.appendChild(ripple);
    ripple.addEventListener('animationend', function () { ripple.remove(); });
  });
})();
